export const VIEWING_APPLY_REMINDER_TEXT =
  'REMINDER: At least one applicant on the application must register or check in using the same email address or mobile number used in the application.'
